import { render, staticRenderFns } from "./lk-date-lead.vue?vue&type=template&id=453bb0a0&"
import script from "./lk-date-lead.vue?vue&type=script&lang=js&"
export * from "./lk-date-lead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-date-lead/lk-date-lead.vue
// module id = 158
// module chunks = 0